import { Benchmark, BenchmarkComparison } from "../types/benchmark.type";

/**
 * getBenchmarkComparison function
 * Compares a video asset's Attention score against a benchmark's score range and returns whether
 * it falls below, within, or above it, along with the delta in percentage points from the nearest
 * range edge (null when the score is within the range).
 *
 * @param score - The asset's Attention score
 * @param benchmark - The applied benchmark to compare against
 * @returns A BenchmarkComparison with status and deltaPercent
 */
export const getBenchmarkComparison = (score: number, benchmark: Benchmark): BenchmarkComparison => {
  if (score < benchmark.scoreRangeMin) {
    return { status: "below", deltaPercent: Math.floor(benchmark.scoreRangeMin - score) };
  }
  if (score > benchmark.scoreRangeMax) {
    return { status: "above", deltaPercent: Math.floor(score - benchmark.scoreRangeMax) };
  }
  return { status: "within", deltaPercent: null };
};
